/* Craciun de Lux: comportamentul sectiunilor cdl-* */
(function () {
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const data = el => { try { return JSON.parse(el.textContent); } catch (e) { return null; } };

  // meniul de pe telefon
  $$('[data-cdl-burger]').forEach(b => b.addEventListener('click', () => {
    const d = document.getElementById(b.getAttribute('aria-controls'));
    if (!d) return; const open = d.classList.toggle('open'); b.setAttribute('aria-expanded', open);
  }));

  // de aproape: taburi, puncte numerotate si lupa
  $$('[data-cdl-closeup]').forEach(root => {
    const cfg = data(root.querySelector('script[type="application/json"]'));
    if (!cfg || !cfg.trees.length) return;
    const tabs = root.querySelector('.cdl-tabs'), stage = root.querySelector('.cdl-stagepic'), img = stage.querySelector('img'),
          loupe = root.querySelector('.cdl-loupe'), list = root.querySelector('.cdl-plist');
    let t = 0, p = 0;
    function render() {
      const tree = cfg.trees[t], pt = tree.pts[p];
      tabs.innerHTML = cfg.trees.map((x, i) => `<button type="button" aria-pressed="${i === t}" data-i="${i}">${x.name}</button>`).join('');
      if (img.getAttribute('src') !== tree.img) { img.src = tree.img; img.alt = tree.name; }
      $$('.cdl-hs', stage).forEach(e => e.remove());
      tree.pts.forEach((q, i) => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'cdl-hs' + (i === p ? ' on' : '');
        b.style.left = q.x + '%'; b.style.top = q.y + '%'; b.textContent = i + 1; b.setAttribute('aria-label', q.title);
        b.onclick = () => { p = i; render(); }; stage.appendChild(b);
      });
      list.innerHTML = tree.pts.map((q, i) => `<div class="cdl-it${i === p ? ' on' : ''}" data-i="${i}"><span class="n">${i + 1}</span><h3>${q.title}</h3><p>${q.text}</p></div>`).join('');
      loupe.style.backgroundImage = `url("${tree.zoom}")`;
      loupe.style.backgroundPosition = `${pt.x}% ${pt.y}%`;
      loupe.style.left = (pt.x > 55 ? pt.x - 48 : pt.x + 6) + '%';
      loupe.style.top = Math.min(Math.max(pt.y - 21, 2), 56) + '%';
      $$('button', tabs).forEach(b => b.onclick = () => { t = +b.dataset.i; p = 0; render(); });
      $$('.cdl-it', list).forEach(d => d.onclick = () => { p = +d.dataset.i; render(); });
    }
    render();
  });

  // pagina bradului: inaltimea aleasa schimba varianta, pretul si detaliile tehnice
  $$('[data-cdl-product]').forEach(root => {
    const cfg = data(root.querySelector('script[data-cdl-config]'));
    if (!cfg) return;
    const idInput = root.querySelector('input[name="id"]'), price = root.querySelector('[data-cdl-price]'),
          sbPrice = root.querySelector('[data-cdl-sb-price]'), sbLabel = root.querySelector('[data-cdl-sb-label]'),
          specs = root.querySelector('[data-cdl-specs]'), specH = root.querySelector('[data-cdl-spec-h]'),
          form = root.querySelector('form.cdl-form'), buy = root.querySelector('.cdl-buy');
    let cur = null;
    const aos = [];
    const lei = c => String(Math.round(c / 100)).replace(/\B(?=(\d{3})+$)/g, '.') + ' lei';
    // pretul de pe buton si din bara de jos, cu suplimentele bifate incluse
    function total() {
      if (!cur) return;
      const on = aos.filter(a => a.on()), sum = on.reduce((s, a) => s + a.variant().cents, cur.cents);
      if (buy && cur.available) buy.textContent = on.length ? `Adaugă în coș · ${lei(sum)}` : 'Adaugă în coș';
      if (sbPrice) sbPrice.textContent = on.length ? lei(sum) : cur.price;
      if (sbLabel) sbLabel.textContent = on.length ? ['Brad'].concat(on.map(a => a.label)).join(' + ')
        : (cur.title === 'Default Title' ? cfg.name : `${cfg.name} · ${cur.title}`);
    }
    function select(v) {
      cur = v;
      idInput.value = v.id;
      if (price) price.firstChild.nodeValue = v.price;
      if (specH) specH.textContent = v.title;
      if (specs && cfg.specs) {
        const rows = [['Înălțime', v.title + ', cu suport']].concat((cfg.specs.byHeight || {})[v.title] || [], cfg.specs.rows || []);
        specs.innerHTML = rows.map(r => `<tr><th>${r[0]}</th><td>${r[1]}</td></tr>`).join('');
      }
      const fz = root.querySelector('[data-cdl-fisa]'), fd = cfg.fisa && cfg.fisa[v.title];
      if (fz && fd) {
        const unit = (x, u) => x.replace(new RegExp(' ' + u + '$'), ' <small>' + u + '</small>');
        fz.querySelector('[data-cdl-fisa-h]').textContent = v.title;
        if (fd.cells) fd.cells.forEach((c, i) => { fz.querySelector(`[data-c="${i}"]`).textContent = c[1]; });
        else {
          fz.querySelector('[data-k="greutate"]').innerHTML = unit(fd.greutate, 'kg');
          fz.querySelector('[data-k="crengute"]').textContent = fd.crengute;
          fz.querySelector('[data-k="diametru"]').innerHTML = unit(fd.diametru, 'm');
          fz.querySelector('[data-k="colet"]').innerHTML = unit(fd.colet, 'm');
        }
      }
      $$('.cdl-heights button', root).forEach(b => b.setAttribute('aria-pressed', b.dataset.id == v.id));
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      total();
    }
    $$('.cdl-heights button', root).forEach(b => b.addEventListener('click', () => select(cfg.variants.find(v => v.id == b.dataset.id))));

    // suplimentele de pe pagina bradului (Mos Craciun, kitul de decoratiuni): culoare si, unde exista, inaltime; intra in cos odata cu bradul
    $$('[data-cdl-ao]', root).forEach(aoRoot => {
      const aoCfg = data(aoRoot.querySelector('script[data-cdl-ao-config]'));
      if (!aoCfg || !aoCfg.length) return;
      const on = aoRoot.querySelector('[data-cdl-ao-on]'), body = aoRoot.querySelector('[data-cdl-ao-body]'), img = aoRoot.querySelector('[data-cdl-ao-img]'),
            link = aoRoot.querySelector('[data-cdl-ao-link]'), color = aoRoot.querySelector('[data-cdl-ao-color]'), sizes = aoRoot.querySelector('[data-cdl-ao-sizes]'),
            colors = $$('[data-cdl-ao-colors] button', aoRoot);
      const firstFree = i => Math.max(aoCfg[i].variants.findIndex(v => v.available), 0);
      let c = Math.min(+aoRoot.dataset.sel || 0, aoCfg.length - 1), s = firstFree(c), shown = -1;
      const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // poza mica: intai fotografia, apoi Mos Craciun care danseaza, descarcat doar pentru culoarea aleasa
      const show = p => {
        shown = aoCfg.indexOf(p); img.src = p.img; img.alt = p.name;
        if (calm || !p.anim) return;
        const a = new Image(); a.onload = () => { if (aoCfg[shown] === p) img.src = p.anim; }; a.src = p.anim;
      };
      const draw = () => {
        const p = aoCfg[c];
        link.href = p.url; color.textContent = p.color;
        if (on.checked && shown !== c) show(p);
        colors.forEach(b => b.setAttribute('aria-pressed', b.dataset.i == c));
        if (sizes) {
          sizes.innerHTML = p.variants.map((v, i) => `<button type="button" data-i="${i}" aria-pressed="${i === s}" ${v.available ? '' : 'disabled'}>${v.title}<small>${v.available ? v.price : 'Stoc epuizat'}</small></button>`).join('');
          $$('button', sizes).forEach(b => b.addEventListener('click', () => { s = +b.dataset.i; draw(); }));
        }
        total();
      };
      colors.forEach(b => b.addEventListener('click', () => {
        c = +b.dataset.i;
        if (!aoCfg[c].variants[s] || !aoCfg[c].variants[s].available) s = firstFree(c);
        draw();
      }));
      const toggle = () => { body.hidden = !on.checked; aoRoot.classList.toggle('on', on.checked); if (on.checked) { aoCfg.forEach(p => { new Image().src = p.img; }); draw(); } total(); };
      on.addEventListener('change', toggle);
      aos.push({ label: aoRoot.dataset.label || 'Supliment', on: () => on.checked, variant: () => aoCfg[c].variants[s] });
      draw(); toggle();
    });
    if (aos.length) {
      const err = root.querySelector('[data-cdl-ao-err]');
      form.addEventListener('submit', e => {
        const on = aos.filter(a => a.on());
        if (!on.length) return;
        e.preventDefault();
        const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        buy.disabled = true; err.hidden = true;
        fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +idInput.value, quantity: 1 }].concat(on.map(a => ({ id: a.variant().id, quantity: 1 }))) }) })
          .then(r => { if (!r.ok) throw new Error(r.status); location.href = base + 'cart'; })
          .catch(() => { buy.disabled = false; err.hidden = false; });
      });
    }

    const start = cfg.variants.find(v => v.id == cfg.selected) || cfg.variants[0];
    if (start) select(start);
    $$('[data-cdl-sticky-buy]', root).forEach(b => b.addEventListener('click', () => form.requestSubmit()));

    // galeria
    const main = root.querySelector('.cdl-gal .main img'), mvid = root.querySelector('.cdl-gal .main video');
    if (mvid && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { mvid.removeAttribute('autoplay'); mvid.pause(); }
    $$('.cdl-thumbs button', root).forEach(b => b.addEventListener('click', () => {
      if (b.hasAttribute('data-video')) {  // miniatura cu dansul: clipul revine in locul pozei
        main.classList.add('cdl-off'); mvid.classList.remove('cdl-off'); mvid.play().catch(() => {});
      } else {
        main.src = b.dataset.full; main.removeAttribute('srcset'); main.classList.remove('cdl-off');
        if (mvid) { mvid.pause(); mvid.classList.add('cdl-off'); }
      }
      $$('.cdl-thumbs button', root).forEach(x => x.setAttribute('aria-pressed', x === b));
    }));
  });

  // clipurile de la fabrica: se descarca doar cand ajung aproape de ecran, pornesc cand se vad
  const vids = $$('video[data-cdl-lazy-video]');
  if (vids.length) {
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const load = v => { if (!v.src) { v.src = innerWidth < 800 ? v.dataset.srcSmall : v.dataset.srcLarge; if (calm && !v.hasAttribute('data-cdl-quiet')) v.controls = true; } };
    if ('IntersectionObserver' in window) {
      const near = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { load(e.target); near.unobserve(e.target); } }), { rootMargin: '300px 0px' });
      const seen = new IntersectionObserver(es => es.forEach(e => { const v = e.target; if (calm) return; if (e.isIntersecting) { load(v); v.play().catch(() => {}); } else v.pause(); }), { threshold: 0.35 });
      vids.forEach(v => { near.observe(v); seen.observe(v); });
    } else vids.forEach(v => { load(v); v.controls = true; });
  }

  // filele din zona de descriere: marcheaza fila apasata
  $$('.cdl-tabs2').forEach(nav => $$('a', nav).forEach(a => a.addEventListener('click', () => { $$('a', nav).forEach(x => x.classList.toggle('on', x === a)); })));

  // data estimata de livrare: intre 1 si 3 zile lucratoare
  $$('[data-cdl-eta]').forEach(el => {
    const z = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'],
          l = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
    const add = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
    const f = d => `${z[d.getDay()]}, ${d.getDate()} ${l[d.getMonth()]}`, now = new Date();
    el.textContent = `Comanzi azi, primești între ${f(add(now, 1))} și ${f(add(now, 3))}`;
  });

  // sirul de luminite din subsol: becurile atarna pe fir
  $$('[data-cdl-lights]').forEach(svg => {
    const w = svg.querySelector('path'), g = svg.querySelector('g'), L = w.getTotalLength(), cols = ['#e6cd8a', '#ffd98c', '#c9a44c'];
    let s = '';
    for (let i = 0; i < 24; i++) {
      const p = w.getPointAtLength(L * (i + .5) / 24), c = cols[i % 3];
      s += `<rect x="${p.x - 2}" y="${p.y}" width="4" height="4" rx="1" fill="#6e5a2a"/><ellipse cx="${p.x}" cy="${p.y + 10}" rx="4.2" ry="6" fill="${c}"><animate attributeName="opacity" values="1;.45;1" dur="${2 + (i % 4) * .6}s" repeatCount="indefinite"/></ellipse>`;
    }
    g.innerHTML = s;
  });
})();
